import React, { useEffect, useState } from "react";
import { BsFillEyeFill } from 'react-icons/bs';
import { Row, Col, Card, Avatar, Rate, Tag, Skeleton, Typography, Checkbox,Tooltip} from "antd";
import history from "../../routes/history";
import Frame from '../../assets/img/Top_rated@2x.svg';
import ex_suitcase from '../../assets/icons/ex_suitcase.png';
import "./GigsCard.css";
import { useDispatch, useSelector } from "react-redux";
import { clearUserSkillListing } from "../../redux/actions";
import moment from "moment";
import { Link } from 'react-router-dom'
import { getImage } from "../../utilities/storageOperations/downloadURL";
import TopAlert from "../../components/TopNotification/TopAlert";
import { formatPhoneNumber, getCookie } from "../../shared/helpers";
import store from "../../redux/store";
import { DefaultRating } from "../../assets/helpers";
import PrivateTagSkillListing from "../../components/PrivateMarketComponents/PrivateTagSkillListing";
import email from "../../assets/icons/email.svg";
import phone from "../../assets/icons/phone.svg";
const authToken = getCookie('token');


const GigsCard = React.memo(props => {
  
  const authToken = getCookie('token');   
  const dispatch = useDispatch()
  const { Text } = Typography;

  //Hooks***************
  const [checked, setChecked] = React.useState(false);
  const [profilePic, setProfilePic] = React.useState();
const [selectCardsMsg, setSelectCardsMsg] = useState(false);
  const [imageError, setImageError] = useState(false);  
 
  //Reducers**************
  const professionCode = useSelector(state => state.profileReducer.user.profile.ProfessionCode)
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const detailsPage = () => {
    dispatch(clearUserSkillListing());
  };

  const [dimensions, setDimensions] = useState(window.innerWidth);
  const title = props.skillTitle ? props.skillTitle : props ? props.Title : 'Skill listing';
  const truncatedTitle = title?.length > 100 ? title?.slice(0, 100) + '...' : title;

  const checkDimensions = () => {
    setDimensions(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", checkDimensions);
  }, []);

  useEffect(() => {
      if(!props?.skillListingIds?.length){
        setChecked(false);
      }
      props.skillListingIds?.find(id => id.SkillListingId == props.SkillListingId) ? setChecked(true) : setChecked(false)

      // const temp = typeof props.skillListingIds === "string" ? JSON.parse(props.skillListingIds):props.skillListingIds;
      // if(temp?.length){
      //   temp?.find(id => id.SkillListingId == props.SkillListingId) ? setChecked(true) : setChecked(false)
      // }
    
  }, [props.skillListingIds,props?.all_data])
  const [visible , setVisible] = useState(false)
  const handleClick = (e) => {
    // e.stopPropagation();  // Prevent click propagation
    // e.stopPropagation();
    setVisible((prev)=> !prev)
  };
  const onCheckChange = (data) => { 
    if (checked == true) {
      setChecked(false)
      var a = props.skillListingIds.filter(si => si.SkillListingId != data.SkillListingId)
      props.setSkillListingIds(a)
      props?.setLocalStorage(props?.localStorageKey, a)
      // localStorage.setItem('SelectedSkills',JSON.stringify(a));
      // props.setcheckAllClicked(false)
    }
    else {
      if (props?.skillListingIds?.length >= 24) { 
        
        setSelectCardsMsg(true)
        setTimeout(() => {
           setSelectCardsMsg(false)
        }, 4000);
        return;
      }
      setChecked(true)
      const temp = typeof props.skillListingIds === "string" ? JSON.parse(props?.skillListingIds) : props?.skillListingIds;
      props.setSkillListingIds([...temp ?? [], data])
      props?.setLocalStorage(props?.localStorageKey,[...temp ?? [], data]);
      // localStorage.setItem('SelectedSkills',JSON.stringify([...props.skillListingIds, data]))
      props.setCandidateId(props.SkillListingId)
    }
  };

  // 👇️ if you only need to capitalize first letter
  const capitalizeFirst = str => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };
  //we dont need to use this method for production images
  
  // useEffect(async () => {
  //   let profilePic = '';
  //   if (props.users) {
  //     if (props.users.Profiles.PictureUrl) {
  //       profilePic = await getImage(props.users.Profiles.PictureUrl)
  //     }
  //     else {
  //       profilePic = await getImage(props.PictureUrl)
  //     }
  //     setProfilePic(profilePic)
  //     // console.log("******&*&*&*&*&", props?.users?.Profiles?.ExperienceLevels?.ExperienceLevelName  )
  //   }
  //   else {
  //     profilePic = await getImage(props.PictureUrl)
  //   }
  // }, [props])

  // Add  a test comment
  
  return (
    <React.Fragment>
      {/* <Link to={`/profiledetail/${props.SkillListingId}`}> */}
      {selectCardsMsg && 
        (
          <TopAlert
           display={"flex"} 
           title={"You have reached the maximum limit of 24 for placing the bids at once "} 
           type="warning" 
           />
          
        ) 
         
      }
  <div>
  <Link to={{
        pathname: `/profiledetail/${props.SkillListingId}`,
        state: {
          currentPage:props.currentPage,
          id: props.SkillListingId,
          token: props.token,
          GigId: props.job_id,
          JobTitle: props.job_title,
          fromMatches: props.findMatch ? true : false,
          Rating: props.Rating,
          Review: props.Review,
          email: props?.users?.EmailAddress,
          searchType: props.searchType,
           jobId: props.job_id,
           jobdetails: props.jobdetails
        },
        
        search: props.findMatch && `matches=${props.findMatch}&jobId=${props.job_id}&skillid=${props.SkillListingId}`
      }}>
        <div
          className="skill-thecard"
          onClick={()=>{store.dispatch(clearUserSkillListing())}}
        >
          <Row className={'cards-top-row'}>

            <div style={{
              position: 'absolute',
              left: '8px',
              //  top:props?.checkboxMargin? props?.checkboxMargin:'-1.7px'
              // top: '-1.7px',
              display:"flex",
              gap: "10px"
            }}>

              {props.token != null && !props.bidstatus  ?
                <Checkbox className="checkboxes"
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => {
                    onCheckChange(props)
                  }}
                  checked={checked}
                  key={props._id}
                />
                : null
              }

              { userProfile?.EmployeeAssociation?.includes(props?.CreatedBy || props?.ModifiedBy ) ? <PrivateTagSkillListing/> : null}
              
            </div>
           
            <div style={{ margin: 'auto' }}>
              <div className={props.token == null ? 'image-circle-container-guest' : "image-circle-container"}>
                <div
                  style={{ marginTop: props?.marginTop ? props?.marginTop : null }}
                  className={props.token != null ? "top-rated-vector" : 'guestUser-vector-icon'}>
                  {/* <img src={Frame} /> */}
                </div>
                <div className='img-containerr'>
                  {/* {props.users ? */}
                  {props?.users?.Profiles?.PictureUrl && !imageError && props?.users?.Profiles?.PictureUrl?.split("/")?.pop() !== "no-pic.png" ?
                    <img
                      className='profile-imagee'
                      alt=""
                      // src={profilePic && profilePic}
                      src={`${process.env.REACT_APP_S3_URL}${props?.users?.Profiles?.PictureUrl?.charAt(0) !== "/" ? '/' : ""
                        }${props?.users?.Profiles?.PictureUrl}`}
                      onError={() => setImageError(true)}
                    /> :
                    <div className='img-textt'>
                      {
                        props?.users && props?.users?.Profiles?.FirstName
                          ? capitalizeFirst(props?.users?.Profiles?.FirstName ? props?.users?.Profiles?.FirstName?.split('')[0] : `C`?.split('')[0])
                          : props?.users?.UserName ?
                            capitalizeFirst(props?.users?.UserName ? props?.users?.UserName?.split('')[0] : `C`?.split('')[0])
                            : 'C'
                      }
                    </div>}
                  {/* : props.candidateName ?
                    <div className='img-textt'>{props.candidateName.split('')[0]}</div> :
                    null
                } */}
                </div>
              </div>
            </div>


            <div style={{
              position: 'absolute',
              right: '0',
              marginRight: '5px',
              // top: props?.eyeMargin? props?.eyeMargin:'-1.7px'
              top: '-1.7px'

            }}>
              {
                props?.token != null && props?.prevviewed ?
                  <BsFillEyeFill
                    style={{
                      color: '#7e7e7e',
                      marginTop: '8px',
                      fontSize: '17px'
                    }}
                    onClick={(e) => e.stopPropagation()} />
                  : null
              }
            </div>



          </Row>

          {/* <div> */}
          {props?.users ?
            <Col className={props.token!==null?"container-meta":"blurName"}>
            
              {props?.users?.Profiles?.FirstName &&
                props?.users?.Profiles?.FirstName != null &&
                props?.users?.Profiles?.FirstName != undefined &&
                props?.users?.Profiles?.FirstName != "" ?
                props?.users?.Profiles?.FirstName + '\n' + props?.users?.Profiles?.LastName
                :
                props && props?.users?.UserName &&
                  props?.users?.UserName != null &&
                  props?.users?.UserName != undefined &&
                  props?.users?.UserName != "" ?

                  props && props?.users?.UserName

                  :
                  'Candidate name'
              }
            </Col>
            :
            <Col className={props.token!==null?"container-meta":"blurName"}
            > Candidate name</Col>
          }

          {/* </div> */}
          <div style={{
            textAlign: 'center', lineHeight: props?.lineheight ? props?.lineheight : '1.1', marginBottom: '7px'
          }}>
            <Rate
              allowHalf className='rate-stars'
              disabled
              defaultValue={props?.users?.Profiles?.Rating == null ||
                props?.users?.Profiles?.Rating == "" ||
                props?.users?.Profiles?.Rating == undefined
                ? DefaultRating : parseFloat(props?.users?.Profiles?.Rating)}
              style={{
                color: "#ffba08"
              }}
            // 
            />
            <Text className='rating-text'>


              <span style={{ color: '#ffba08', fontSize: '12px' }}>
                {props?.users?.Profiles?.Rating == null ||
                  props?.users?.Profiles?.Rating == "" ||
                  props?.users?.Profiles?.Rating == undefined
                  ? DefaultRating : props?.users?.Profiles?.Rating}</span>

              {props?.users?.Profiles?.Review == null ||
                props?.users?.Profiles?.Review == "" ||
                props?.users?.Profiles?.Review == undefined ||
                props?.users?.Profiles?.Review == 0
                ? '' : '(' + props?.users?.Profiles?.Review
                + ')'}

            </Text>
          </div>
          <Col className="skill-listing-title" onMouseEnter={()=>{setVisible(true)}} onMouseLeave={()=>{setVisible(false)}}>
      <Tooltip title={truncatedTitle} mouseEnterDelay={0.5} visible={visible}>
        <div>{truncatedTitle?.length > 100 ? truncatedTitle?.slice(0,20) + "..." : truncatedTitle}</div>
      </Tooltip>
    </Col>
          <Row className="desired-rate-div">
            <Col xs={24} className="desired-rate">
             {userProfile?.Professions?.ProfessionCode == 'HC' ?
              (

                props?.MinimumBid &&
                  props?.MinimumBid != null &&
                  props?.MinimumBid != "" &&
                  props?.MinimumBid != undefined ?
                  (
                    <div className="rate-value">
                      <Text className="desired-rate-text">
                      Desired rate
                        
                      </Text>

                      {props?.MinimumBid?.$numberDecimal ?
                        (
                          props?.MinimumBid?.$numberDecimal?.slice(0, -3) > 0 ?
                            (
                              // '$' + (props?.MinimumBid?.$numberDecimal)?.slice(0, -3) +
                              '$' + (props?.MinimumBid?.$numberDecimal)?.toLocaleString('en-US') +
                              (props?.BudgetTypes &&
                                props?.BudgetTypes?.BudgetTypeName != "" &&
                                props?.BudgetTypes?.BudgetTypeName != null &&
                                props?.BudgetTypes?.BudgetTypeName != undefined?
                                `/${
                                      props?.BudgetTypes?.BudgetTypeName=== "hr" ||
                                      props?.BudgetTypes?.BudgetTypeName=== "Hour"? 
                                      "HR" 
                                      :
                                      props?.BudgetTypes?.BudgetTypeName === "yr" || 
                                      props?.BudgetTypes?.BudgetTypeName === "Year"? 
                                      "YR" 
                                      :
                                       props?.BudgetTypes?.BudgetTypeName === "Week" || 
                                       props?.BudgetTypes?.BudgetTypeName === "wk"? 
                                       "WK" 
                                       :
                                        "YR"}`
                                :
                                '/N/A')
                            )
                            :
                            ('$Negotiable')
                        )
                        :
                        (
                          props?.MinimumBid > 0 ?
                            (
                              '$' + (props?.MinimumBid).toLocaleString('en-US') +
                              (props?.BudgetTypes &&
                                props?.BudgetTypes?.BudgetTypeName != "" &&
                                props?.BudgetTypes?.BudgetTypeName != null &&
                                props?.BudgetTypes?.BudgetTypeName != undefined?
                                `/${
                                  props?.BudgetTypes?.BudgetTypeName=== "Hour" || 
                                  props?.BudgetTypes?.BudgetTypeName=== "hour" ?
                                 "HR" 
                                 : 
                                 props?.BudgetTypes?.BudgetTypeName === "yr" || 
                                 props?.BudgetTypes?.BudgetTypeName === "Year" ? 
                                 "YR" 
                                 :
                                 props?.BudgetTypes?.BudgetTypeName === "Week" || 
                                 props?.BudgetTypes?.BudgetTypeName === "wk" ?
                                  "WK" 
                                 :
                                 "YR"}`
                                :
                                '/N/A')
                            )
                            :
                            ('$Negotiable')

                        )
                      }
                    </div>
                  )
                  :
                  <div className="rate-value">
                    <Text className="desired-rate-text">
                  Desired rate
                    </Text>
                    Negotiable
                  </div>
             
              )
              :
              (
                
              // userProfile?.Professions?.ProfessionCode !== 'IT' ?

                props?.ClientRate &&
                  props?.ClientRate != null &&
                  props?.ClientRate != "" &&
                  props?.ClientRate != undefined ?
                  (
                    <div className="rate-value">
                      <Text className="desired-rate-text">
                      Est. Amount
                        
                      </Text>

                      {props?.ClientRate?.$numberDecimal ?
                        (
                          props?.ClientRate?.$numberDecimal > 0 ?
                            (
                              '$' + parseFloat(props?.ClientRate?.$numberDecimal)?.toFixed(2) +
                              (props?.BudgetTypes &&
                                props?.BudgetTypes?.BudgetTypeName != null &&
                                props?.BudgetTypes?.BudgetTypeName != "" &&
                                props?.BudgetTypes?.BudgetTypeName != undefined ?
                                `/${
                                  props?.BudgetTypes?.BudgetTypeName=== "Hour" || 
                                  props?.BudgetTypes?.BudgetTypeName=== "hour" ?
                                 "HR" 
                                 : 
                                 props?.BudgetTypes?.BudgetTypeName === "yr" || 
                                 props?.BudgetTypes?.BudgetTypeName === "Year" ? 
                                 "YR" 
                                 :
                                 props?.BudgetTypes?.BudgetTypeName === "Week" || 
                                 props?.BudgetTypes?.BudgetTypeName === "wk" ?
                                  "WK" 
                                 :
                                 "YR"}`
                                : 
                                props?.JobOrderTypes?.JobOrderTypeName === "Permanent" ? '/' + "YR" : '/' + "HR")
                            )
                            :
                            ('$Negotiable')
                        )
                        :
                        (
                          props?.ClientRate > 0 ?
                            (
                              '$' + (props?.ClientRate?.toFixed(2)) +
                              (props?.BudgetTypes &&
                                props?.BudgetTypes?.BudgetTypeName != null &&
                                props?.BudgetTypes?.BudgetTypeName != "" &&
                                props?.BudgetTypes?.BudgetTypeName != undefined ?
                                `/${
                                  props?.BudgetTypes?.BudgetTypeName=== "Hour" || 
                                  props?.BudgetTypes?.BudgetTypeName=== "hour" ?
                                 "HR" 
                                 : 
                                 props?.BudgetTypes?.BudgetTypeName === "yr" || 
                                 props?.BudgetTypes?.BudgetTypeName === "Year" ? 
                                 "YR" 
                                 :
                                 props?.BudgetTypes?.BudgetTypeName === "Week" || 
                                 props?.BudgetTypes?.BudgetTypeName === "wk" ?
                                  "WK" 
                                 :
                                 "YR"}`
                                : props?.JobOrderTypes?.JobOrderTypeName === "Permanent" ? '/' + "YR" : '/' + "HR"
                              )
                            )
                            :
                            ('$Negotiable')

                        )
                      }
                    </div>
                  )
                  :
                  <div className="rate-value">
                    <Text className="desired-rate-text">
                     Est. Amount
                    </Text>
                    $Negotiable
                  </div>
              
            
              )
              }
            </Col>
          </Row>
          <Row className="Experience-row" style={{ 
            height:'2.6rem',
            width:'9rem',
            marginLeft:'auto',
            marginRight:'auto'}}>
            <Col lg={20} xs={24} className="experience">
              <img className="briefcase-img" src={ex_suitcase} alt="" />
              {
                props?.explevel &&
                  props?.explevel != null &&
                  props?.explevel != "" &&
                  props?.explevel != undefined ?

                  <Text style={{ marginLeft: '8px' }}>
                    {props?.explevel[0]?.ExperienceLevelName &&
                      props?.explevel[0]?.ExperienceLevelName != null &&
                      props?.explevel[0]?.ExperienceLevelName != "" &&
                      props?.explevel[0]?.ExperienceLevelName != undefined ?
                      props?.explevel[0]?.ExperienceLevelName
                      : 'N/A'
                    } of experience
                  </Text>

                  :

                  <Text style={{ marginLeft: '8px' }}>

                    N/A
                  </Text>
              }
              
              {/* {
              props?.users?.Profiles?.ExperienceLevels  && 
              props?.users?.Profiles?.ExperienceLevels != null &&
              props?.users?.Profiles?.ExperienceLevels != "" && 
              props?.users?.Profiles?.ExperienceLevels != undefined ?
               
               <Text style={{ marginLeft: '8px' }}>
                {props?.users?.Profiles?.ExperienceLevels?.ExperienceLevelName ? 
                  props?.users?.Profiles?.ExperienceLevels?.ExperienceLevelName 
                  : 'N/A'
                }
                </Text>

                :
                
                <Text style={{ marginLeft: '8px' }}>
                {props && props?.users?.Profiles?.ExperienceLevels ? 
                  props?.users?.Profiles?.ExperienceLevels
                  : 
                  'N/A'
                }
                </Text>
            } */}

            
            </Col>
          </Row>
          { userProfile?.EmployeeAssociation?.includes(props?.CreatedBy) || 
            userProfile?.EmployeeAssociation?.includes(props?.ModifiedBy)
          ? (
  <>
   
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
      <span style={{ display: "flex", alignItems: "center" }}>
        <img src={email} alt="" style={{ maxWidth: "100%", height: "auto" }} />
      </span>
      <span style={{ fontSize: "12px", overflow: "hidden", textOverflow: "ellipsis", color: "#4054B2" }}>
        {props?.users?.EmailAddress ?? "N/A"}
      </span>
    </div>
    <div style={{ display: "flex", gap: "5px", justifyContent: "center", alignItems: "center" }} >
      <span style={{ display: "flex", alignItems: "center" }} ><img src={phone} alt="" /></span>
      <span style={{ fontSize: "12px", color: "#3E3E3E" }}>{props?.users?.MobilePhone 
        ? formatPhoneNumber(props?.users?.MobilePhone?.toString())
        : "N/A"}
      </span>
    </div>
  </>
) : null}


          {
            props?.users?.LastSuccessfulLoginDate &&
              props?.users?.LastSuccessfulLoginDate != null &&
              props?.users?.LastSuccessfulLoginDate != "" &&
              props?.users?.LastSuccessfulLoginDate != undefined ?
              


              <div className={'last-active-text'}>
              
                Last active  {moment(props?.users?.LastSuccessfulLoginDate).fromNow()}
              </div>
              :
              <div className={'last-active-text'}>
                Last active  N/A
              </div>
          }

        </div>
      </Link>
   {
    window.innerWidth <786 ? 
    <div style={{padding:"11px" , position:"relative", bottom:"175px"}}
    onClick={handleClick} onMouseLeave={()=>setVisible(false)}></div>
    :""
   }
  </div>
    </React.Fragment>
  );
});

export default GigsCard;